import React from 'react'
import { connect, useDispatch } from 'react-redux'
import { submit } from 'redux-form'
import { Textarea } from '../../../../itrust_common/components/form'
import FindingFieldWrap from '../../../../itrust_common/components/authorised/impressionFinding/exam/formField/FindingFieldWrap'

function AutoCodeChiefComplaint(props) {
  const { showFindingField, findings } = props
  const dispatch = useDispatch()

  const handleExamCommentChange = (e) => {
    if (!showFindingField || findings.length == 0) {
      setTimeout(() => dispatch(submit("examHeaderForm")), 500)
    }
  }

  return (
    <>
      <FindingFieldWrap
        name="hpis_attributes[0][chief_complaint]"
        rows={3}
        fieldValues={{ custom_label: 'Chief Complaint', visible: 'true' }}
        wrapperClasses="form-group col-12"
        className="form-control"
        component={Textarea}
        type="findingField"
        fieldType="textarea"
        onBlur={handleExamCommentChange}
        isHeaderModule={true}
      />
    </>
  )
}

const mapStateToProps = state => {
  const { examFinding } = state

  return {
    findings: examFinding.findings,
  }
}

export default connect(mapStateToProps)(AutoCodeChiefComplaint)